import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

const AttachmentSettings = (props) => {
  const { serviceProductForm } = props

  const {
    entityState: {
      options: { attachable },
    },
    handlers,
  } = serviceProductForm

  const { required, string } = attachable

  return (
    <DashboardModule title="Attachment Settings">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Required">
            <select
              data-value-type="boolean"
              name="options.attachable.required"
              value={required}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>

          {required && (
            <Form.Field label="String" marginTop={['large', 0]}>
              <input
                name="options.attachable.string"
                type="text"
                value={string}
                {...handlers}
              />
            </Form.Field>
          )}
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

AttachmentSettings.propTypes = {
  serviceProductForm: PropTypes.object,
}

export default AttachmentSettings
